import { NgClass } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { KlarnaPaymentComponentDef } from '@df/module-klarna/klarna-payment.component.def';
import { ResultComponent } from '../../ui/resut/result.component';
@Component({
    selector: 'klarna-payment',
    templateUrl: './klarna-payment.html',
    styleUrls: ['./klarna-payment.scss'],
    standalone: true,
    imports: [ResultComponent, NgClass],
    encapsulation: ViewEncapsulation.None
})
export class KlarnaPaymentComponent extends KlarnaPaymentComponentDef {}
